import React, { useState, useEffect } from 'react';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { PlaceIdProvider } from './contexts/PlaceContext';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router } from 'react-router-dom';
import { themeOptions } from './components/ThemeOption';
import { NotificationProvider } from './components/NotificationContext';
import { NotificationApiHook } from './components/NotificationApiHook';
import AppInner from './pages/AppInner';
import { VersionProvider } from './contexts/VersionContext';

const theme = createTheme(themeOptions);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <NotificationApiHook>
          <AuthProvider>
            <PlaceIdProvider>
              <VersionProvider>
                <CssBaseline />
                <Router>
                  <AppInner />
                </Router>
              </VersionProvider>
            </PlaceIdProvider>
          </AuthProvider>
        </NotificationApiHook>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App;
